import styled from "styled-components";

const StatusStyle = styled.span`
  & span {
    padding: 4px 8px;
    color: #fff;
    background-color: #525961;
    border-radius: 5px;
  }
  & .new {
    background-color: #3f66fb;
  }
  & .partition {
    background-color: #b57bff;
  }
  & .prarector {
    background-color: #fd8e39;
  }
  & .rector {
    background-color: #3dc03c;
  }
  & .canceled {
    background-color: #f03637;
  }
`;
const StatusShow = ({ s = 1 }) => {
  return (
    <>
      <StatusStyle>
        {s === 1 ? (
          <span className="new">Yuborildi</span>
        ) : s === 2 ? (
          <span className="partition">Bo'lim tasdiqladi</span>
        ) : s === 3 ? (
          <span className="prarector">Prorektor tasdiqladi</span>
        ) : s === 4 ? (
          <span className="rector">Rektor tasdiqladi</span>
        ) : s === 5 ? (
          <span className="canceled">Bekor qilindi</span>
        ) : s === 6 ? (
          <span>Ko'ribchiqilmadi</span>
        ) : (
          <span>{s}</span>
        )}
      </StatusStyle>
    </>
  );
};
export default StatusShow;
